export const MOODS = {
  VOID: {
    name: 'VOID',
    bg: 'bg-zinc-950',
    intensity: 0.2,
    blur: 'backdrop-blur-xl',
    glow: 'shadow-[0_0_30px_rgba(255,255,255,0.05)]',
    speedMult: 0.4,
    starDensity: 0.5,
    lineSpeed: 1,
    carSpeed: 1.5,
    flareBrightness: 0.2,
    smokeAlpha: 0.05,
    ignitionDelay: 1.2
  },
  AURA: {
    name: 'AURA',
    bg: 'bg-neutral-900',
    intensity: 0.5,
    blur: 'backdrop-blur-lg',
    glow: 'shadow-[0_0_40px_rgba(255,255,255,0.1)]',
    speedMult: 1.0,
    starDensity: 1.0,
    lineSpeed: 2.5,
    carSpeed: 3,
    flareBrightness: 0.5,
    smokeAlpha: 0.15,
    ignitionDelay: 1.0
  },
  PULSE: {
    name: 'PULSE',
    bg: 'bg-slate-950',
    intensity: 1.2,
    blur: 'backdrop-blur-md',
    glow: 'shadow-[0_0_60px_rgba(255,255,255,0.2)]',
    speedMult: 2.5,
    starDensity: 2.0,
    lineSpeed: 6,
    carSpeed: 8,
    flareBrightness: 1.0,
    smokeAlpha: 0.4,
    ignitionDelay: 0.8
  }
};

export const ACCENTS = {
  RED: { name: 'Racing Red', color: '#ff1801', glow: 'shadow-red-500/50', border: 'border-red-500/30' },
  BLUE: { name: 'Electric Blue', color: '#00d2ff', glow: 'shadow-blue-500/50', border: 'border-blue-500/30' },
  PURPLE: { name: 'Bright Purple', color: '#8F1FE3', glow: 'shadow-purple-500/50', border: 'border-purple-500/50' }
};
